import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

interface UseWorkerForcedCancellationWarningResult {
  shouldShowWarning: boolean;
}

export function useWorkerForcedCancellationWarning(
  workplaceId: string | undefined
): UseWorkerForcedCancellationWarningResult {
  const config = useCbhFlag(CbhFeatureFlag.WORKER_FORCED_CANCELLATION_CHAT_WARNING, {
    defaultValue: {
      workplaceIds: [],
    },
  });

  // Defensively handle missing workplaceIds (e.g., when flag is "Off" variation)
  const workplaceIds = config.workplaceIds ?? [];

  const shouldShowWarning = isDefined(workplaceId) && workplaceIds.includes(workplaceId);

  return { shouldShowWarning };
}
